import { Navigate, useParams, type RouteObject } from "react-router-dom";
import { peekRoadAssistCheckoutState } from "../lib/use-road-assist-checkout-state";
import { lazyWithReload } from "../lib/lazy-with-reload";

// Authenticated `(app)` pages are code-split: each becomes its own chunk that
// loads only when its route is matched. The marketing/auth pages below stay
// eagerly imported so the public landing path paints without a chunk
// round-trip. The shared <Suspense> boundary lives in `AppShellWithGuard`,
// which wraps the <Outlet /> these elements render into.
const ContPage = lazyWithReload(() => import("./views/app/Cont"));
const ContProfilPage = lazyWithReload(() => import("./views/app/ContProfil"));
const ContAdresePage = lazyWithReload(() => import("./views/app/ContAdrese"));
const ContAdreseEditeazaPage = lazyWithReload(() => import("./views/app/ContAdreseEditeaza"));
const ContAdreseNouaPage = lazyWithReload(() => import("./views/app/ContAdreseNoua"));
const ContDocumentePage = lazyWithReload(() => import("./views/app/ContDocumente"));
const ContDocumenteDetaliuPage = lazyWithReload(() => import("./views/app/ContDocumenteDetaliu"));
const ContDocumenteEditeazaPage = lazyWithReload(() => import("./views/app/ContDocumenteEditeaza"));
const ContDocumenteNouPage = lazyWithReload(() => import("./views/app/ContDocumenteNou"));
const ContDocumenteRcaPage = lazyWithReload(() => import("./views/app/ContDocumenteRca"));
const ContPersoanePage = lazyWithReload(() => import("./views/app/ContPersoane"));
const ContPersoaneEditeazaPage = lazyWithReload(() => import("./views/app/ContPersoaneEditeaza"));
const ContPersoaneNouPage = lazyWithReload(() => import("./views/app/ContPersoaneNou"));
const ContSetariPage = lazyWithReload(() => import("./views/app/ContSetari"));
const CumparaCalatorieCererePage = lazyWithReload(() => import("./views/app/CumparaCalatorieCerere"));
const CumparaCalatorieContractPage = lazyWithReload(() => import("./views/app/CumparaCalatorieContract"));
const CumparaCalatorieDetaliiPage = lazyWithReload(() => import("./views/app/CumparaCalatorieDetalii"));
const CumparaMalpraxisContractPage = lazyWithReload(() => import("./views/app/CumparaMalpraxisContract"));
const CumparaMalpraxisDetaliiPage = lazyWithReload(() => import("./views/app/CumparaMalpraxisDetalii"));
const CumparaMalpraxisOfertePage = lazyWithReload(() => import("./views/app/CumparaMalpraxisOferte"));
const CumparaMalpraxisSumarPage = lazyWithReload(() => import("./views/app/CumparaMalpraxisSumar"));
const CumparaMalpraxisPlataPage = lazyWithReload(() => import("./views/app/CumparaMalpraxisPlata"));
const CumparaMalpraxisEmiterePage = lazyWithReload(() => import("./views/app/CumparaMalpraxisEmitere"));
const CumparaMalpraxisSuccesPage = lazyWithReload(() => import("./views/app/CumparaMalpraxisSucces"));
const CumparaMalpraxisEroarePage = lazyWithReload(() => import("./views/app/CumparaMalpraxisEroare"));
const CumparaMalpraxisCererePage = lazyWithReload(() => import("./views/app/CumparaMalpraxisCerere"));
const CumparaPadDetaliiPage = lazyWithReload(() => import("./views/app/CumparaPadDetalii"));
const CumparaPadContractPage = lazyWithReload(() => import("./views/app/CumparaPadContract"));
const CumparaPadOfertaPage = lazyWithReload(() => import("./views/app/CumparaPadOferta"));
const CumparaPadSumarPage = lazyWithReload(() => import("./views/app/CumparaPadSumar"));
const CumparaPadPlataPage = lazyWithReload(() => import("./views/app/CumparaPadPlata"));
const CumparaPadEmiterePage = lazyWithReload(() => import("./views/app/CumparaPadEmitere"));
const CumparaPadSuccesPage = lazyWithReload(() => import("./views/app/CumparaPadSucces"));
const CumparaPadEroarePage = lazyWithReload(() => import("./views/app/CumparaPadEroare"));
const CumparaPadCererePage = lazyWithReload(() => import("./views/app/CumparaPadCerere"));
const CumparaRoadAssistDetaliiPage = lazyWithReload(() => import("./views/app/CumparaRoadAssistDetalii"));
const CumparaRoadAssistContractPage = lazyWithReload(() => import("./views/app/CumparaRoadAssistContract"));
const CumparaRoadAssistOfertePage = lazyWithReload(() => import("./views/app/CumparaRoadAssistOferte"));
const CumparaRoadAssistSumarPage = lazyWithReload(() => import("./views/app/CumparaRoadAssistSumar"));
const CumparaRoadAssistPlataPage = lazyWithReload(() => import("./views/app/CumparaRoadAssistPlata"));
const CumparaRoadAssistEmiterePage = lazyWithReload(() => import("./views/app/CumparaRoadAssistEmitere"));
const CumparaRoadAssistSuccesPage = lazyWithReload(() => import("./views/app/CumparaRoadAssistSucces"));
const CumparaRoadAssistEroarePage = lazyWithReload(() => import("./views/app/CumparaRoadAssistEroare"));
const CumparaRoadAssistCererePage = lazyWithReload(() => import("./views/app/CumparaRoadAssistCerere"));
const CumparaCalatorieEmiterePage = lazyWithReload(() => import("./views/app/CumparaCalatorieEmitere"));
const CumparaCalatorieEroarePage = lazyWithReload(() => import("./views/app/CumparaCalatorieEroare"));
const CumparaCalatorieOfertePage = lazyWithReload(() => import("./views/app/CumparaCalatorieOferte"));
const CumparaCalatoriePlataPage = lazyWithReload(() => import("./views/app/CumparaCalatoriePlata"));
const CumparaCalatorieSuccesPage = lazyWithReload(() => import("./views/app/CumparaCalatorieSucces"));
const CumparaCalatorieSumarPage = lazyWithReload(() => import("./views/app/CumparaCalatorieSumar"));
const CumparaRcaCererePage = lazyWithReload(() => import("./views/app/CumparaRcaCerere"));
const CumparaRcaContractPage = lazyWithReload(() => import("./views/app/CumparaRcaContract"));
const CumparaRcaDatePage = lazyWithReload(() => import("./views/app/CumparaRcaDate"));
const CumparaRcaEmiterePage = lazyWithReload(() => import("./views/app/CumparaRcaEmitere"));
const CumparaRcaEroarePage = lazyWithReload(() => import("./views/app/CumparaRcaEroare"));
const CumparaRcaOfertePage = lazyWithReload(() => import("./views/app/CumparaRcaOferte"));
const CumparaRcaPlataPage = lazyWithReload(() => import("./views/app/CumparaRcaPlata"));
const CumparaRcaSucesPage = lazyWithReload(() => import("./views/app/CumparaRcaSucces"));
const CumparaRcaSumarPage = lazyWithReload(() => import("./views/app/CumparaRcaSumar"));
const MasiniPage = lazyWithReload(() => import("./views/app/Masini"));
const MasiniAdaugaPage = lazyWithReload(() => import("./views/app/MasiniAdauga"));
const MasiniDetaliuPage = lazyWithReload(() => import("./views/app/MasiniDetaliu"));
const MasiniEditeazaPage = lazyWithReload(() => import("./views/app/MasiniEditeaza"));
const NotificariPage = lazyWithReload(() => import("./views/app/Notificari"));
const ProdusePage = lazyWithReload(() => import("./views/app/Produse"));
const AdminHomePage = lazyWithReload(() => import("./views/admin/AdminHome"));
const AdminClientiPage = lazyWithReload(() => import("./views/admin/AdminClienti"));
const AdminClientDetaliuPage = lazyWithReload(() => import("./views/admin/AdminClientDetaliu"));
const AdminPolitaNouaPage = lazyWithReload(() => import("./views/admin/AdminPolitaNoua"));
const AdminSuspectiPage = lazyWithReload(() => import("./views/admin/AdminSuspecti"));
const AdminSetariPage = lazyWithReload(() => import("./views/admin/AdminSetari"));
const AdminAjutorPage = lazyWithReload(() => import("./views/admin/AdminAjutor"));
import InregistrarePage from "./views/auth/Inregistrare";
import LoginPage from "./views/auth/Login";
import ParolaUitataPage from "./views/auth/ParolaUitata";
import AjutorArticolPage from "./views/marketing/AjutorArticol";
import AjutorPage from "./views/marketing/Ajutor";
import CompanionPage from "./views/marketing/Companion";
import ConfidentialitatePage from "./views/marketing/Confidentialitate";
import DesprePage from "./views/marketing/Despre";
import FunctiiPage from "./views/marketing/Functii";
import Home from "./views/marketing/Home";
import IntrebariPage from "./views/marketing/Intrebari";
import TermeniPage from "./views/marketing/Termeni";
import { AdminShellWithGuard } from "./shells/AdminShellWithGuard";
import { AppShellWithGuard } from "./shells/AppShellWithGuard";
import { AuthShell } from "./shells/AuthShell";
import { MarketingShell } from "./shells/MarketingShell";

// Mirrors the route table in `docs/routes.md`. Three top-level
// shells group the pages by chrome:
// - MarketingShell: 9 public pages (`/`, `/functii`, …) + 2 redirects.
// - AuthShell: 2 sign-in / sign-up pages.
// - AppShellWithGuard: 19 authenticated `(app)` pages (cars, account,
//   documents, persons, addresses, notifications, products), plus the
//   checkout steps and two email-link redirects (`/notification/:id`,
//   `/notificationSettings`).
//
// Redirects in the MarketingShell children block mirror Next.js rules that
// live in `next.config.ts` today. They go away when Phase 6 deletes that
// config; new Vite-side redirects land here regardless of whether a
// matching Next.js rule exists.
//
// The `*` catch-all at the bottom redirects any unmatched path to `/`
// so users are never stranded on a blank 404 page.
export const routes: RouteObject[] = [
  {
    element: <MarketingShell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/functii", element: <FunctiiPage /> },
      { path: "/despre", element: <DesprePage /> },
      { path: "/intrebari", element: <IntrebariPage /> },
      { path: "/app", element: <CompanionPage /> },
      {
        path: "/confidentialitate",
        element: <ConfidentialitatePage />,
      },
      { path: "/termeni", element: <TermeniPage /> },
      { path: "/ajutor", element: <AjutorPage /> },
      {
        path: "/ajutor/:slug",
        element: <AjutorArticolPage />,
      },
      // Permanent redirects — the Next.js rules live in `next.config.ts`
      // and go away when Phase 6 deletes that config. New Vite-side
      // redirects land here regardless of where the corresponding Next.js
      // rule sits (or whether one exists at all).
      {
        path: "/info/:slug",
        element: <RedirectInfoToAjutor />,
      },
      {
        path: "/terms",
        element: <Navigate to="/termeni" replace />,
      },
      {
        path: "/companion",
        element: <Navigate to="/app" replace />,
      },
    ],
  },
  {
    element: <AuthShell />,
    children: [
      {
        path: "/cont/login",
        element: <LoginPage />,
      },
      {
        path: "/cont/inregistrare",
        element: <InregistrarePage />,
      },
      {
        path: "/cont/parola-uitata",
        element: <ParolaUitataPage />,
      },
    ],
  },
  {
    element: <AppShellWithGuard />,
    children: [
      // Cars
      { path: "/masini", element: <MasiniPage /> },
      {
        path: "/masini/adauga",
        element: <MasiniAdaugaPage />,
      },
      {
        path: "/masini/:carId",
        element: <MasiniDetaliuPage />,
      },
      {
        path: "/masini/:carId/editeaza",
        element: <MasiniEditeazaPage />,
      },
      // Account
      { path: "/cont", element: <ContPage /> },
      { path: "/cont/profil", element: <ContProfilPage /> },
      {
        path: "/cont/setari",
        element: <ContSetariPage />,
      },
      // Documents
      {
        path: "/cont/documente",
        element: <ContDocumentePage />,
      },
      {
        path: "/cont/documente/nou",
        element: <ContDocumenteNouPage />,
      },
      {
        path: "/cont/documente/:docId",
        element: <ContDocumenteDetaliuPage />,
      },
      {
        path: "/cont/documente/:docId/editeaza",
        element: <ContDocumenteEditeazaPage />,
      },
      {
        path: "/cont/documente/rca/:rcaId",
        element: <ContDocumenteRcaPage />,
      },
      // Persons
      {
        path: "/cont/persoane",
        element: <ContPersoanePage />,
      },
      {
        path: "/cont/persoane/nou",
        element: <ContPersoaneNouPage />,
      },
      {
        path: "/cont/persoane/:personId/editeaza",
        element: <ContPersoaneEditeazaPage />,
      },
      // Addresses
      {
        path: "/cont/adrese",
        element: <ContAdresePage />,
      },
      {
        path: "/cont/adrese/noua",
        element: <ContAdreseNouaPage />,
      },
      {
        path: "/cont/adrese/:addressId/editeaza",
        element: <ContAdreseEditeazaPage />,
      },
      // Notifications
      {
        path: "/notificari",
        element: <NotificariPage />,
      },
      // Links from every alert email and calendar event (shared flow: docs/flows/deep-links.md).
      // Inside the guard so a signed-out visitor signs in and comes back to the link itself.
      // `replace` keeps the link out of history: back from the reminder never re-runs the redirect.
      { path: "/notification/:id", element: <RedirectNotificationToNotificari /> },
      { path: "/notificationSettings", element: <Navigate to="/cont/setari" replace /> },
      // Products
      { path: "/produse", element: <ProdusePage /> },
      // Buy RCA — multi-step checkout. The flow uses one URL per step so
      // browser back/forward, refresh, and the post-payment return URL all
      // land somewhere coherent. Each step view enforces its own prereq
      // redirects (e.g. `/sumar` redirects to `/oferte` if no offer is picked).
      {
        path: "/cumpara/rca",
        element: <RedirectToRcaStart />,
      },
      { path: "/cumpara/rca/date", element: <CumparaRcaDatePage /> },
      { path: "/cumpara/rca/contract", element: <CumparaRcaContractPage /> },
      { path: "/cumpara/rca/oferte", element: <CumparaRcaOfertePage /> },
      { path: "/cumpara/rca/sumar", element: <CumparaRcaSumarPage /> },
      { path: "/cumpara/rca/plata", element: <CumparaRcaPlataPage /> },
      { path: "/cumpara/rca/emitere", element: <CumparaRcaEmiterePage /> },
      { path: "/cumpara/rca/succes", element: <CumparaRcaSucesPage /> },
      { path: "/cumpara/rca/eroare", element: <CumparaRcaEroarePage /> },
      { path: "/cumpara/rca/cerere", element: <CumparaRcaCererePage /> },
      // Buy Travel (Călătorie) — multi-step checkout. Same per-URL-step model
      // as RCA; each step view enforces its own prereq redirects.
      { path: "/cumpara/calatorie", element: <RedirectToCalatorieStart /> },
      { path: "/cumpara/calatorie/detalii", element: <CumparaCalatorieDetaliiPage /> },
      { path: "/cumpara/calatorie/contract", element: <CumparaCalatorieContractPage /> },
      { path: "/cumpara/calatorie/oferte", element: <CumparaCalatorieOfertePage /> },
      { path: "/cumpara/calatorie/sumar", element: <CumparaCalatorieSumarPage /> },
      { path: "/cumpara/calatorie/plata", element: <CumparaCalatoriePlataPage /> },
      { path: "/cumpara/calatorie/emitere", element: <CumparaCalatorieEmiterePage /> },
      { path: "/cumpara/calatorie/succes", element: <CumparaCalatorieSuccesPage /> },
      { path: "/cumpara/calatorie/eroare", element: <CumparaCalatorieEroarePage /> },
      { path: "/cumpara/calatorie/cerere", element: <CumparaCalatorieCererePage /> },
      // Buy Malpraxis — multi-step checkout. Same per-URL-step model as RCA/Travel;
      // each step view enforces its own prereq redirects.
      { path: "/cumpara/malpraxis", element: <RedirectToMalpraxisStart /> },
      { path: "/cumpara/malpraxis/detalii", element: <CumparaMalpraxisDetaliiPage /> },
      { path: "/cumpara/malpraxis/contract", element: <CumparaMalpraxisContractPage /> },
      { path: "/cumpara/malpraxis/oferte", element: <CumparaMalpraxisOfertePage /> },
      { path: "/cumpara/malpraxis/sumar", element: <CumparaMalpraxisSumarPage /> },
      { path: "/cumpara/malpraxis/plata", element: <CumparaMalpraxisPlataPage /> },
      { path: "/cumpara/malpraxis/emitere", element: <CumparaMalpraxisEmiterePage /> },
      { path: "/cumpara/malpraxis/succes", element: <CumparaMalpraxisSuccesPage /> },
      { path: "/cumpara/malpraxis/eroare", element: <CumparaMalpraxisEroarePage /> },
      { path: "/cumpara/malpraxis/cerere", element: <CumparaMalpraxisCererePage /> },
      // Buy PAD (Locuință) — multi-step checkout. Same per-URL-step model as
      // RCA/Travel/Malpraxis; each step view enforces its own prereq redirects.
      { path: "/cumpara/pad", element: <RedirectToPadStart /> },
      { path: "/cumpara/pad/detalii", element: <CumparaPadDetaliiPage /> },
      { path: "/cumpara/pad/contract", element: <CumparaPadContractPage /> },
      { path: "/cumpara/pad/oferta", element: <CumparaPadOfertaPage /> },
      { path: "/cumpara/pad/sumar", element: <CumparaPadSumarPage /> },
      { path: "/cumpara/pad/plata", element: <CumparaPadPlataPage /> },
      { path: "/cumpara/pad/emitere", element: <CumparaPadEmiterePage /> },
      { path: "/cumpara/pad/succes", element: <CumparaPadSuccesPage /> },
      { path: "/cumpara/pad/eroare", element: <CumparaPadEroarePage /> },
      { path: "/cumpara/pad/cerere", element: <CumparaPadCererePage /> },
      // Buy Asistență rutieră — multi-step checkout. Same per-URL-step model as
      // RCA/Travel/Malpraxis/PAD; each step view enforces its own prereq redirects.
      { path: "/cumpara/roadAssist", element: <RedirectToRoadAssistStart /> },
      { path: "/cumpara/roadAssist/detalii", element: <CumparaRoadAssistDetaliiPage /> },
      { path: "/cumpara/roadAssist/contract", element: <CumparaRoadAssistContractPage /> },
      { path: "/cumpara/roadAssist/oferte", element: <CumparaRoadAssistOfertePage /> },
      { path: "/cumpara/roadAssist/sumar", element: <CumparaRoadAssistSumarPage /> },
      { path: "/cumpara/roadAssist/plata", element: <CumparaRoadAssistPlataPage /> },
      { path: "/cumpara/roadAssist/emitere", element: <CumparaRoadAssistEmiterePage /> },
      { path: "/cumpara/roadAssist/succes", element: <CumparaRoadAssistSuccesPage /> },
      { path: "/cumpara/roadAssist/eroare", element: <CumparaRoadAssistEroarePage /> },
      { path: "/cumpara/roadAssist/cerere", element: <CumparaRoadAssistCererePage /> },
    ],
  },
  {
    element: <AdminShellWithGuard />,
    children: [
      { path: "/admin", element: <AdminHomePage /> },
      { path: "/admin/clienti", element: <AdminClientiPage /> },
      { path: "/admin/clienti/:uid", element: <AdminClientDetaliuPage /> },
      { path: "/admin/clienti/:uid/polita-noua", element: <AdminPolitaNouaPage /> },
      { path: "/admin/suspecti", element: <AdminSuspectiPage /> },
      { path: "/admin/setari", element: <AdminSetariPage /> },
      { path: "/admin/ajutor", element: <AdminAjutorPage /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

// `/cumpara/rca` itself isn't a page — it forwards to `/date` if a checkout
// is in progress in this tab, otherwise back to `/produse` where the user
// picks a car.
function RedirectToRcaStart() {
  const hasState =
    typeof window !== "undefined" &&
    Boolean(window.sessionStorage.getItem("rca-checkout-v1"));
  return <Navigate to={hasState ? "/cumpara/rca/date" : "/produse"} replace />;
}

function RedirectToCalatorieStart() {
  const hasState =
    typeof window !== "undefined" &&
    Boolean(window.sessionStorage.getItem("travel-checkout-v1"));
  return <Navigate to={hasState ? "/cumpara/calatorie/detalii" : "/produse"} replace />;
}

function RedirectToMalpraxisStart() {
  const hasState =
    typeof window !== "undefined" &&
    Boolean(window.sessionStorage.getItem("malpraxis-checkout-v1"));
  return <Navigate to={hasState ? "/cumpara/malpraxis/detalii" : "/produse"} replace />;
}

function RedirectToPadStart() {
  const hasState =
    typeof window !== "undefined" &&
    Boolean(window.sessionStorage.getItem("pad-checkout-v1"));
  return <Navigate to={hasState ? "/cumpara/pad/detalii" : "/produse"} replace />;
}

function RedirectToRoadAssistStart() {
  const env = peekRoadAssistCheckoutState();
  return <Navigate to={env ? "/cumpara/roadAssist/detalii" : "/produse"} replace />;
}

// `/notificari` consumes `?id=` once the reminders load: it opens that reminder's edit dialog (or says
// it no longer exists) and drops the param from the URL.
export function RedirectNotificationToNotificari() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/notificari?id=${encodeURIComponent(id)}` : "/notificari"} replace />;
}

function RedirectInfoToAjutor() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/ajutor/${slug ?? ""}`} replace />;
}
